import template from "./bOvertimeApplicationsTable.html";
import moment from "moment";

export function bOvertimeApplicationsTableDirective() {
  'ngInject';

  const directive = {
    restrict: 'E',
    template: template,
    controller: bOvertimeApplicationsTableController,
    controllerAs: 'bOvertimeApplicationsTable',
    bindToController: true,
    scope: {
      title: "@?",
      status: "=?",
      applications: "=?",
      isEmployeeView: "=",
      newApplication: "&",
      acceptApplication: "&",
      editApplication: "&",
      deleteApplication: "&",
      allocateApplication: "&",
      viewApplication: "&",
      rejectApplication: "&",
      showModalWithWorklogs: "&",
      settleApplication: "&",
      supervisors: "=?",
      noEmployees: "=?"
    }
  };

  return directive;
}

class bOvertimeApplicationsTableController {
  constructor($translate) {
    'ngInject';

    this.$translate = $translate;

    this.statusTypes = {
      New: this.$translate.instant("OVERTIME_APPLICATION.STATUS_TYPES.NEW"),
      Sent: this.$translate.instant("OVERTIME_APPLICATION.STATUS_TYPES.SENT"),
      ToAccept: this.$translate.instant("OVERTIME_APPLICATION.STATUS_TYPES.TO_ACCEPT"),
      Accepted: this.$translate.instant("OVERTIME_APPLICATION.STATUS_TYPES.ACCEPTED"),
      UpdateDone: this.$translate.instant("OVERTIME_APPLICATION.STATUS_TYPES.UPDATE_DONE"),
      RequestedUpdate: this.$translate.instant("OVERTIME_APPLICATION.STATUS_TYPES.REQUESTED_UPDATE"),
      NewUpdate: this.$translate.instant("OVERTIME_APPLICATION.STATUS_TYPES.NEW_UPDATE"),
      CompletedPartially: this.$translate.instant("OVERTIME_APPLICATION.STATUS_TYPES.COMPLETED_PARTIALLY"),
      CompletedPositively: this.$translate.instant("OVERTIME_APPLICATION.STATUS_TYPES.COMPLETED_POSITIVELY"),
      CompletedNegatively: this.$translate.instant("OVERTIME_APPLICATION.STATUS_TYPES.COMPLETED_NEGATIVELY"),
      AllocatedPartially: this.$translate.instant("OVERTIME_APPLICATION.STATUS_TYPES.ALLOCATED_PARTIALLY"),
      Allocated: this.$translate.instant("OVERTIME_APPLICATION.STATUS_TYPES.ALLOCATED"),
      Settled: this.$translate.instant("OVERTIME_APPLICATION.STATUS_TYPES.SETTLED"),
      SettledPartially: this.$translate.instant("OVERTIME_APPLICATION.STATUS_TYPES.SETTLED_PARTIALLY"),
      Rejected: this.$translate.instant("OVERTIME_APPLICATION.STATUS_TYPES.REJECTED")
    };

    this.notFinishedStatuses = ['requestedChanges', 'startedApplications', 'accepted', 'waitingForAcceptanceApplications'];
    this.moment = moment;

    this.$onInit = () => {
      this.canRequestChanges = this.notFinishedStatuses.includes(this.status) && this.isEmployeeView;

      this.getters = {
        applicationCode: (value) => {
          const number = value.applicationCode.split('-')[0];
          return parseInt(number);
        }
      };
    };
  }

  canAccept(application) {
    return this.status === 'waitingForAcceptanceApplications' && !this.isEmployeeView && !application.acceptedBy;
  }

  canEditOrDelete(application) {
    return this.isEmployeeView ? application.status === 'ToAccept' : ['requestedChanges', 'waitingForAcceptanceApplications', 'accepted'].includes(this.status);
  }

  canAllocate(application) {
    return application.reportedDuration !== '00:00:00' && ['finished', 'settledOrAllocated'].includes(this.status) && !['Allocated', 'Rejected', 'Settled', 'SettledPartially'].includes(application.status);
  }

  canSettle(application) {
    return application.reportedDuration !== '00:00:00' && ['finished', 'settledOrAllocated'].includes(this.status) && !['Allocated', 'Rejected', 'Settled', 'AllocatedPartially'].includes(application.status);
  }

  printClients(clients) {
    return clients.map(client => (client.additionalInfo ? `(${client.additionalInfo}) ` : "") + client.name).join(', ');
  }

  printStatus(status) {
    return this.statusTypes[status];
  }

  requestChanges(application) {
    application.requestChanges = true;

    if (!application.employeeAccepted)
      application.employeeAccepted = true;

    this.editApplication({application});
  }

  canView(application) {
    return this.isEmployeeView && !application.employeeAccepted && this.status === 'waitingForAcceptanceApplications';
  }

  canReject() {
    return this.notFinishedStatuses.includes(this.status);
  }
}
